// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   IconButton,
//   LinearProgress,
// } from '@mui/material';
// import { Edit, Delete } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminBudsActComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedBudsAct, setSelectedBudsAct] = useState(null);

//   const [formData, setFormData] = useState({
//     subject: '',
//     date_of_issue: '',
//     language: '',
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteBudsAct, setDeleteBudsAct] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'subject', field: 'subject', headerName: 'Subject', width: 250 },
//     { id: 'dateOfIssue', field: 'dateOfIssue', headerName: 'Date Of Issue', width: 150 },
//     { id: 'language', field: 'language', headerName: 'Language', width: 150 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: 'Links',
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">
//             Download
//           </a>
//         ) : (
//           'No File'
//         ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchBudsActs();
//   }, []);

//   const fetchBudsActs = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/budsact/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           subject: item.subject,
//           dateOfIssue: item.date_of_issue,
//           language: item.language,
//           links: item.link || '',
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch BUDS Act data:', error);
//         setSnackbarMessage('Failed to load BUDS Act & Rules data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddBudsAct = () => {
//     setIsEditMode(false);
//     setFormData({ subject: '', date_of_issue: '', language: '' });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (budsAct) => {
//     setIsEditMode(true);
//     setSelectedBudsAct(budsAct);
//     setFormData({
//       subject: budsAct.subject,
//       date_of_issue: budsAct.dateOfIssue,
//       language: budsAct.language,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (budsAct) => {
//     setDeleteBudsAct(budsAct);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/budsact/${deleteBudsAct.id}/`)
//       .then(() => {
//         setSnackbarMessage('BUDS Act deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchBudsActs();
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete BUDS Act.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteBudsAct(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.subject?.trim()) errors.subject = 'Subject is required';
//     if (!formData.date_of_issue) errors.date_of_issue = 'Date is required';
//     if (!formData.language?.trim()) errors.language = 'Language is required';
//     if (!selectedFile && !isEditMode) errors.file = 'File is required';
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors((prev) => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('subject', formData.subject);
//     form.append('date_of_issue', formData.date_of_issue);
//     form.append('language', formData.language);
//     if (selectedFile) form.append('link', selectedFile);

//     try {
//       setUploading(true);
//       setUploadProgress(0);

//       if (isEditMode) {
//         await api.patch(`${API_BASE_URL}/home-notification/budsact/${selectedBudsAct.id}/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => {
//             setUploadProgress(Math.round((e.loaded * 100) / e.total));
//           },
//         });
//         setSnackbarMessage('BUDS Act updated successfully.');
//       } else {
//         await api.post(`${API_BASE_URL}/home-notification/budsact/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => {
//             setUploadProgress(Math.round((e.loaded * 100) / e.total));
//           },
//         });
//         setSnackbarMessage('BUDS Act added successfully.');
//       }

//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       fetchBudsActs();
//       setOpenFormDialog(false);
//     } catch (error) {
//       console.error('Submit failed:', error);
//       setSnackbarMessage('Failed to submit BUDS Act.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   };

//   if (loading) return <LoadingSpinner size={30} />;

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Admin BUDS Act & Rules
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddBudsAct} disabled={uploading}>
//           Add BUDS Act
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//       />

//       <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit BUDS Act' : 'Add BUDS Act'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Subject"
//             fullWidth
//             value={formData.subject}
//             error={!!formErrors.subject}
//             helperText={formErrors.subject}
//             onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Date of Issue"
//             type="date"
//             fullWidth
//             value={formData.date_of_issue}
//             error={!!formErrors.date_of_issue}
//             helperText={formErrors.date_of_issue}
//             onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Language"
//             fullWidth
//             value={formData.language}
//             error={!!formErrors.language}
//             helperText={formErrors.language}
//             onChange={(e) => setFormData({ ...formData, language: e.target.value })}
//             disabled={uploading}
//           />
//           <Box mt={2}>
//             <input
//               type="file"
//               accept="*"
//               style={{ display: 'block', marginTop: 8 }}
//               onChange={handleFileChange}
//               disabled={uploading}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error" sx={{ mt: 1 }}>
//                 {formErrors.file}
//               </Typography>
//             )}
//             {isEditMode && !selectedFile && selectedBudsAct?.links && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a href={`${API_BASE_URL}${selectedBudsAct.links}`} target="_blank" rel="noopener noreferrer">
//                   Download
//                 </a>
//               </Typography>
//             )}
//           </Box>
//           {uploading && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
//                 Uploading... {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button variant="contained" color="primary" onClick={handleFormSubmit} disabled={uploading}>
//             {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this BUDS Act entry?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button variant="contained" color="error" onClick={handleDelete} disabled={uploading}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };

import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  LinearProgress,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminBudsActComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedBudsAct, setSelectedBudsAct] = useState(null);

  const [formData, setFormData] = useState({
    subject: '',
    date_of_issue: '',
    language: '',
    rank: '', // Added rank
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteBudsAct, setDeleteBudsAct] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'subject', field: 'subject', headerName: 'Subject', width: 250 },
    { id: 'dateOfIssue', field: 'dateOfIssue', headerName: 'Date Of Issue', width: 150 },
    { id: 'language', field: 'language', headerName: 'Language', width: 150 },
    { id: 'rank', field: 'rank', headerName: 'Rank', width: 100 }, // Display rank
    {
      id: 'links',
      field: 'links',
      headerName: 'Links',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            Download
          </a>
        ) : (
          'No File'
        ),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchBudsActs();
  }, []);

  const fetchBudsActs = () => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/home-notification/budsact/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          subject: item.subject,
          dateOfIssue: item.date_of_issue,
          language: item.language,
          rank: item.rank || '', // Receive rank
          links: item.link || '',
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch BUDS Act data:', error);
        setSnackbarMessage('Failed to load BUDS Act & Rules data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddBudsAct = () => {
    setIsEditMode(false);
    setFormData({ subject: '', date_of_issue: '', language: '', rank: '' });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleEdit = (budsAct) => {
    setIsEditMode(true);
    setSelectedBudsAct(budsAct);
    setFormData({
      subject: budsAct.subject,
      date_of_issue: budsAct.dateOfIssue,
      language: budsAct.language,
      rank: budsAct.rank || '',
    });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (budsAct) => {
    setDeleteBudsAct(budsAct);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api
      .delete(`/home-notification/budsact/${deleteBudsAct.id}/`)
      .then(() => {
        setSnackbarMessage('BUDS Act deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchBudsActs();
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete BUDS Act.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteBudsAct(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.subject?.trim()) errors.subject = 'Subject is required';
    if (!formData.date_of_issue) errors.date_of_issue = 'Date is required';
    if (!formData.language?.trim()) errors.language = 'Language is required';
    if (!formData.rank?.trim()) errors.rank = 'Rank is required'; // validation for rank
    if (!selectedFile && !isEditMode) errors.file = 'File is required';
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
      setSelectedFile(null);
    } else {
      setFormErrors((prev) => ({ ...prev, file: null }));
      setSelectedFile(file);
    }
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const form = new FormData();
    form.append('subject', formData.subject);
    form.append('date_of_issue', formData.date_of_issue);
    form.append('language', formData.language);
    form.append('rank', formData.rank); // include rank in submission
    if (selectedFile) form.append('link', selectedFile);

    try {
      setUploading(true);
      setUploadProgress(0);

      if (isEditMode) {
        await api.patch(`/home-notification/budsact/${selectedBudsAct.id}/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => {
            setUploadProgress(Math.round((e.loaded * 100) / e.total));
          },
        });
        setSnackbarMessage('BUDS Act updated successfully.');
      } else {
        await api.post(`/home-notification/budsact/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => {
            setUploadProgress(Math.round((e.loaded * 100) / e.total));
          },
        });
        setSnackbarMessage('BUDS Act added successfully.');
      }

      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchBudsActs();
      setOpenFormDialog(false);
    } catch (error) {
      console.error('Submit failed:', error);
      setSnackbarMessage('Failed to submit BUDS Act.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) return <LoadingSpinner size={30} />;

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Admin BUDS Act & Rules
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddBudsAct} disabled={uploading}>
          Add BUDS Act
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? 'Edit BUDS Act' : 'Add BUDS Act'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Subject"
            fullWidth
            value={formData.subject}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Date of Issue"
            type="date"
            fullWidth
            value={formData.date_of_issue}
            error={!!formErrors.date_of_issue}
            helperText={formErrors.date_of_issue}
            onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })}
            InputLabelProps={{ shrink: true }}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Language"
            fullWidth
            value={formData.language}
            error={!!formErrors.language}
            helperText={formErrors.language}
            onChange={(e) => setFormData({ ...formData, language: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Rank"
            fullWidth
            value={formData.rank}
            error={!!formErrors.rank}
            helperText={formErrors.rank}
            onChange={(e) => setFormData({ ...formData, rank: e.target.value })}
            disabled={uploading}
          />
          <Box mt={2}>
            <input
              type="file"
              accept="*"
              style={{ display: 'block', marginTop: 8 }}
              onChange={handleFileChange}
              disabled={uploading}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {formErrors.file}
              </Typography>
            )}
            {isEditMode && !selectedFile && selectedBudsAct?.links && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{' '}
                <a href={`${API_BASE_URL}${selectedBudsAct.links}`} target="_blank" rel="noopener noreferrer">
                  Download
                </a>
              </Typography>
            )}
          </Box>
          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleFormSubmit} disabled={uploading}>
            {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this BUDS Act entry?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete} disabled={uploading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
